<template>
  <b-overlay :show="isCreatingClient" rounded="sm">
    <b-card class="card--container">
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center">
          <span v-if="mode === 'CREATE'">Novo cliente</span>
          <span v-else>Atualizar cliente</span>
        </div>
      </template>

      <b-row class="mb-2" v-if="isAdmin">
        <b-col>
          <label>
            Corretor <span class="text-danger">*</span>
          </label>

          <b-select
            v-model="assigneeId"
            :options="brokers"
            :disabled="settings.isLoadingBrokers"
          >
            <template v-slot:first>
              <b-select-option :value="null">
                Selecione um corretor
              </b-select-option>
            </template>
          </b-select>
        </b-col>
      </b-row>

      <hr class="mt-3" v-if="isAdmin">

      <b-row>
        <b-col>
          <b-card class="bg-light border-0">
            <b-row class="mb-3">
              <b-col>
                <label>
                  Interesse <span class="text-danger">*</span>
                </label>
                <b-form-group class="mb-0">
                  <b-form-checkbox-group
                    v-model="client.interests"
                    :options="interests"
                    name="interests"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <label>
                  Captação <span class="text-danger">*</span>
                </label>
                <b-form-radio-group
                  v-model="client.origin"
                  :options="origins"
                  name="origin"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <hr class="mt-3">

      <b-row class="mt-3 mb-2">
        <b-col>
          <strong>Informações pessoais</strong>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="6" class="mb-2">
          <label>
            Nome <span class="text-danger">*</span>
          </label>
          <b-input v-model.trim="client.firstName"/>
        </b-col>
        <b-col lg="6" class="mb-2">
          <label>
            Sobrenome <span class="text-danger">*</span>
          </label>
          <b-input v-model.trim="client.lastName"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="mb-2">
          <label>
            CPF
          </label>
          <b-input v-model.trim="client.cpf" v-mask="'###.###.###-##'"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="mb-2">
          <label>
            Email
          </label>
          <b-input v-model.trim="client.email"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="6" class="mb-2">
          <label>
            Telefone
          </label>
          <b-input v-model.trim="client.phone" v-mask="'(##) ####-####'"/>
        </b-col>

        <b-col lg="6" class="mb-2">
          <label>
            Celular <span class="text-danger">*</span>
          </label>
          <b-input v-model.trim="client.mobile" v-mask="'(##) #####-####'"/>
        </b-col>
      </b-row>

      <hr class="mt-3">

      <b-row class="mt-2 mb-2">
        <b-col>
          <strong>Informações de renda</strong>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="6" class="mb-2">
          <label>
            Tipo de renda
          </label>
          <b-form-group class="mb-0">
            <b-form-radio-group v-model="income.type" name="income-type">
              <b-form-radio value="FORM">Formal</b-form-radio>
              <b-form-radio value="INFO">Informal</b-form-radio>
              <b-form-radio value="MIST">Mista</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col lg="6" class="mb-2">
          <label>
            Valor
          </label>
          <b-input-group prepend="R$">
            <b-input v-model.trim="income.value" v-mask="numberMask"/>
          </b-input-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="6" class="mb-2">
          <label>
            Possui FGTS
          </label>
          <b-form-group class="mb-0">
            <b-form-radio-group v-model="fgts.check" name="fgts">
              <b-form-radio :value="true">Sim</b-form-radio>
              <b-form-radio :value="false">Não</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col lg="6" class="mb-2">
          <label>
            Valor
          </label>
          <b-input-group prepend="R$">
            <b-input v-model.trim="fgts.value" :disabled="!fgts.check" v-mask="numberMask"/>
          </b-input-group>
        </b-col>
      </b-row>

      <b-row class="mt-1 mb-2">
        <b-col>
          <button class="toggle" v-b-toggle.address>
            <span>Endereço</span>

            <hr/>

            <small>
              <b-icon-chevron-down />
            </small>
          </button>
          <b-collapse id="address">
            <b-row>
              <b-col lg="6" class="mt-2 mb-2">
                <label>CEP</label>

                <b-input-group>
                  <b-input v-model.trim="address.zipcode" v-mask="'#####-###'"></b-input>

                  <template v-slot:append>
                    <b-button
                      @click="fetchAddress()"
                      :disabled="address.zipcode.length < 9 || address.loading"
                    >
                      <span v-if="!address.loading">Pesquisar</span>

                      <div v-else>
                        Pesquisando

                        <b-spinner small class="text-white ml-1"/>
                      </div>
                    </b-button>
                  </template>
                </b-input-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="8" class="mb-2">
                <label>Logradouro</label>
                <b-input v-model.trim="address.street"/>
              </b-col>

              <b-col lg="4" class="mb-2">
                <label>Número</label>
                <b-input v-model.trim="address.houseNumber"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="4" class="mb-2">
                <label>Bairro</label>
                <b-input v-model.trim="address.neighborhood"/>
              </b-col>

              <b-col lg="4" class="mb-2">
                <label>Cidade</label>
                <b-input type="text" v-model="address.city" disabled />
                <!-- <b-form-select
                  v-model.trim="address.city"
                  :options="address.cities"
                /> -->
              </b-col>

              <b-col lg="4" class="mb-2">
                <label>Estado</label>
                <b-input type="text" v-model="address.state" disabled />

                <!-- <b-form-select v-model.trim="address.state" disabled>
                  <b-form-select-option :value="null">
                    Selecione um estado
                  </b-form-select-option>
                  <b-form-select-option value="AC">Acre</b-form-select-option>
                  <b-form-select-option value="AL">Alagoas</b-form-select-option>
                  <b-form-select-option value="AP">Amapá</b-form-select-option>
                  <b-form-select-option value="AM">Amazonas</b-form-select-option>
                  <b-form-select-option value="BA">Bahia</b-form-select-option>
                  <b-form-select-option value="CE">Ceará</b-form-select-option>
                  <b-form-select-option value="ES">Espírito Santo</b-form-select-option>
                  <b-form-select-option value="ES">ES</b-form-select-option>
                  <b-form-select-option value="GO">Goiás</b-form-select-option>
                  <b-form-select-option value="MA">Maranhão</b-form-select-option>
                  <b-form-select-option value="MT">Mato Grosso</b-form-select-option>
                  <b-form-select-option value="MS">Mato Grosso do Sul</b-form-select-option>
                  <b-form-select-option value="MG">Minas Gerais</b-form-select-option>
                  <b-form-select-option value="PA">Pará</b-form-select-option>
                  <b-form-select-option value="PB">Paraíba</b-form-select-option>
                  <b-form-select-option value="PR">Paraná</b-form-select-option>
                  <b-form-select-option value="PE">Pernambuco</b-form-select-option>
                  <b-form-select-option value="PI">Piauí</b-form-select-option>
                  <b-form-select-option value="RJ">Rio de Janeiro</b-form-select-option>
                  <b-form-select-option value="RN">Rio Grande do Norte</b-form-select-option>
                  <b-form-select-option value="RS">Rio Grande do Sul</b-form-select-option>
                  <b-form-select-option value="RO">Rondônia</b-form-select-option>
                  <b-form-select-option value="RR">Roraima</b-form-select-option>
                  <b-form-select-option value="SC">Santa Catarina</b-form-select-option>
                  <b-form-select-option value="SP">São Paulo</b-form-select-option>
                  <b-form-select-option value="SE">Sergipe</b-form-select-option>
                  <b-form-select-option value="TO">Tocantins</b-form-select-option>
                  <b-form-select-option value="DF">Distrito Federal</b-form-select-option>
                </b-form-select> -->
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <button class="toggle" v-b-toggle.partner-in-marriage>
            <span>Informações do cônjuge</span>

            <hr />

            <small>
              <b-icon-chevron-down />
            </small>
          </button>
          <b-collapse id="partner-in-marriage">
            <b-row class="mt-2">
              <b-col lg="6" class="mb-2">
                <label>Nome</label>
                <b-input v-model.trim="partner.firstName"/>
              </b-col>
              <b-col lg="6" class="mb-2">
                <label>Sobrenome</label>
                <b-input v-model.trim="partner.lastName"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="mb-2">
                <label>CPF</label>
                <b-input v-model.trim="partner.cpf" v-mask="'###.###.###-##'"/>
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>

      <b-row>
        <b-col></b-col>
      </b-row>

      <template v-slot:footer>
        <div class="text-right">
          <b-button
            variant="outline-secondary"
            size="sm"
            @click="cancel()"
          >
            Cancelar
          </b-button>

          <b-button
            variant="primary"
            size="sm"
            class="ml-2"
            :disabled="isInvalid"
            @click="submit()"
          >
            <span v-if="mode === 'CREATE'">Cadastrar</span>
            <span v-if="mode === 'EDIT'">Atualizar</span>
          </b-button>
        </div>
      </template>
    </b-card>
  </b-overlay>
</template>

<script>
import router from '@/router/index';
import ClientInterestsEnum from '@/enums/clientInterests';
import ClientOriginsEnum from '@/enums/clientOrigins';
import { ClientsService, ProjectsService } from '@/services';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import numeral from 'numeral';
import { mapState } from 'vuex';

numeral.register('locale', 'pt-BR', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
});

numeral.locale('pt-BR');

const currencyMask = createNumberMask({
  prefix: '',
  allowDecimal: true,
  includeThousandsSeparator: true,
  allowNegative: false,
  decimalSymbol: ',',
  thousandsSeparatorSymbol: '.',
  integerLimit: 6,
});
export default {
  props: ['mode', 'data'],

  data() {
    return {
      isCreatingClient: false,
      isEditingClient: false,
      assigneeId: null,
      origins: ClientOriginsEnum.toList(),
      interests: ClientInterestsEnum.toList(),
      client: {
        firstName: '',
        lastName: '',
        cpf: '',
        email: '',
        phone: '',
        mobile: '',
        interests: [],
        origin: '',
      },
      address: {
        loading: false,
        cities: [],
        zipcode: '',
        street: '',
        neighborhood: '',
        houseNumber: '',
        city: '',
        state: null,
      },
      partner: {
        firstName: '',
        lastName: '',
        cpf: '',
      },
      income: {
        type: 'FORM',
        value: '',
      },
      fgts: {
        check: true,
        value: '',
      },
      numberMask: currencyMask,
    };
  },

  async created() {
    if (this.isAdmin) {
      await this.$store.dispatch('settings/fetchBrokers', { companyId: this.user.company_id });
    }

    if (this.mode === 'CREATE') {
      if (this.isAdmin) {
        if (this.brokers.length === 1) {
          this.assigneeId = this.brokers[0].value;
        }
      } else {
        this.assigneeId = this.user.uid;
      }
    } else {
      this.assignValues();
    }
  },

  computed: {
    ...mapState(['settings']),

    brokers() {
      return [
        ...this
          .settings
          .brokers
          .map((broker) => ({
            text: `${broker.first_name} ${broker.last_name}`,
            value: broker.uid,
          })),
      ];
    },

    isInvalid() {
      return this.client.interests.length === 0
        || !this.client.origin
        || !this.client.firstName
        || !this.client.lastName
        || !this.client.mobile
        || !this.assigneeId;
    },
  },

  methods: {
    async assignValues() {
      const { interests } = this.data;

      this.assigneeId = this.data.assignee_id;

      this.client = {
        firstName: this.data.first_name,
        lastName: this.data.last_name,
        cpf: this.data.cpf,
        email: this.data.email,
        phone: this.data.main_phone,
        mobile: this.data.mobile_phone,
        interests: Array.isArray(interests) ? interests : [interests],
        origin: this.data.origin,
      };

      this.address = {
        zipcode: this.data.zipcode,
        street: this.data.street,
        neighborhood: this.data.neighborhood,
        houseNumber: this.data.house_number,
        city: this.data.city,
        state: this.data.state || null,
      };

      this.partner = {
        firstName: this.data.partner_first_name,
        lastName: this.data.partner_last_name,
        cpf: this.data.partner_cpf,
      };

      this.income = {
        type: this.data.income_type,
        value: (this.data.income_value)
          ? numeral(this.data.income_value).format('0,0.00')
          : '',
      };

      this.fgts = {
        check: this.data.has_fgts,
        value: (this.data.fgts)
          ? numeral(this.data.income_value).format('0,0.00')
          : '',
      };

      // if (this.data.zipcode) {
      //   this.updateCities().then(() => {
      //     this.address.city = this.address.localidade;
      //   });
      // }

      // await this.updateCities();

      // this.address.city = this.data.city || '';

      // this.$emit('done');
    },

    toFloat(num) {
      if (num === '') {
        return '';
      }

      return parseFloat(num.replace('.', '').replace(',', '.'));
    },

    cancel() {
      router.push('/clients');
    },

    submit() {
      if (this.mode === 'CREATE') {
        this.create();
      } else {
        this.update();
      }
    },

    getClientObj() {
      const data = {
        assignee_id: this.$data.assigneeId || null,
        company_id: this.user.company_id,
        cpf: this.$data.client.cpf,
        city: this.$data.client.city,
        email: this.$data.client.email,
        fgts: this.toFloat(this.$data.fgts.value),
        first_name: this.$data.client.firstName,
        has_fgts: this.$data.fgts.check,
        house_number: this.$data.address.houseNumber,
        income_type: this.$data.income.type,
        income_value: this.toFloat(this.$data.income.value),
        interests: this.$data.client.interests,
        last_name: this.$data.client.lastName,
        main_phone: this.$data.client.phone,
        mobile_phone: this.$data.client.mobile,
        neighborhood: this.$data.address.neighborhood,
        origin: this.$data.client.origin,
        partner_cpf: this.$data.partner.cpf,
        partner_first_name: this.$data.partner.firstName,
        partner_last_name: this.$data.partner.lastName,
        street: this.$data.address.street,
        state: this.$data.address.state,
        user_id: this.user.uid,
        zipcode: this.$data.address.zipcode,
      };

      Object.keys(data).forEach((key) => {
        if (data[key] === undefined) {
          data[key] = null;
        }
      });

      return data;
    },

    async create() {
      this.isCreatingClient = true;

      try {
        const client = this.getClientObj();

        const task = {
          assignee_id: client.assignee_id,
          user_id: this.user.uid,
          company_id: this.user.company_id,
          title: `${client.first_name} ${client.last_name}`,
        };

        /* TODO: Refactor to vuex */
        const clientId = await ClientsService.createClient(client);
        await ProjectsService.createDefaultProjectTask({
          client_id: clientId,
          ...task,
        });

        this.$store.commit('global/SET_NOTIFICATION', {
          variant: 'success',
          content: 'Cliente cadastrado com sucesso',
          title: 'Sucesso!',
        }, { root: true });

        this.$emit('register', this.getClientObj());
      } catch (err) {
        console.log(err);
        this.$store.commit('global/SET_NOTIFICATION', {
          variant: 'danger',
          content: 'Não foi possível cadastrar o cliente',
          title: 'Ops! Encontramos um problema',
        }, { root: true });
      }

      this.isCreatingClient = false;
    },

    async update() {
      this.isCreatingClient = true;

      try {
        await ClientsService.updateClient(this.data.uid, this.getClientObj());

        this.$store.commit('global/SET_NOTIFICATION', {
          variant: 'success',
          content: 'Cliente atualizado com sucesso',
          title: 'Sucesso!',
        }, { root: true });
      } catch (err) {
        console.log(err);
        this.$store.commit('global/SET_NOTIFICATION', {
          variant: 'danger',
          content: 'Não foi possível atualizar o cliente',
          title: 'Ops! Encontramos um problema',
        }, { root: true });
      }

      this.isCreatingClient = false;
    },

    edit() {
      this.isEditingClient = true;
    },

    fetchAddress() {
      this.address.loading = true;

      fetch(`https://viacep.com.br/ws/${this.address.zipcode.replace('-', '')}/json/`)
        .then((response) => response.json())
        .then(async (address) => {
          this.address.street = address.logradouro;
          this.address.neighborhood = address.bairro;
          this.address.state = address.uf;

          await this.updateCities();

          this.address.city = address.localidade;

          this.address.loading = false;
        })
        .catch((err) => {
          console.log(err);

          this.$store.commit('global/SET_NOTIFICATION', {
            variant: 'danger',
            content: 'Endereço não encontrado',
            title: 'Ops! Encontramos um problema',
          }, { root: true });

          this.address.street = '';
          this.address.neighborhood = '';
          this.address.city = '';
          this.address.state = '';

          this.address.loading = false;
        });
    },

    updateCities() {
      this.address.city = '';
      this.address.cities = [];

      return new Promise((resolve) => {
        if (this.address.state !== null) {
          fetch('/mocks/cities.json')
            .then((response) => response.json())
            .then((states) => {
              this.address.cities = states
                .filter((state) => state.sigla === this.address.state)
                .pop()
                .cidades;

              console.log(this.address);
            });
        } else {
          this.address.cities = [];
        }

        resolve();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .toggle {
    align-items: center;
    background: none;
    border: none;
    color: #212529;
    display: flex;
    font-weight: 700;
    justify-content: space-between;
    outline: none;
    padding: 0;
    position: relative;
    width: 100%;

    span {
      white-space: nowrap;
    }

    hr {
      border: none;
      border-bottom: 1px solid rgba(0, 0, 0, .125);
      display: block;
      margin: 0 15px;
      width: 100%;
    }
  }

  @media all and (max-width: 768px) {
    #__BVID__27,
    #__BVID__32 {
      display: flex;
      flex-direction: column;
    }
  }
</style>
